<template>
  <div class="car-user-data">
    <div class="car-items">
      <div class="car-item" v-if="booking.givenname">
        <span class="car-label">{{$t('quote.customerDetails.firstName')}}:</span><span class="car-text">{{ booking.givenname }}</span>
      </div>
      <div class="car-item" v-if="booking.surname">
        <span class="car-label">{{$t('quote.customerDetails.lastName')}}:</span><span class="car-text">{{ booking.surname }}</span>
      </div>
      <div class="car-item" v-if="booking.phone">
        <span class="car-label">{{$t('quote.customerDetails.phone')}}:</span><span class="car-text">{{ booking.phone }}</span>
      </div>
      <div class="car-item" v-if="booking.emailAddress">
        <span class="car-label">{{$t('quote.customerDetails.email')}}:</span><span class="car-text">{{ booking.emailAddress }}</span>
      </div>
      <div class="car-item" v-if="booking.comment">
        <span class="car-label">{{$t('quote.customerDetails.comment')}}:</span><span class="car-text">{{ booking.comment }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomerDetails',
  props: {
    booking: {
      required: true
    }
  }
}
</script>
